import {useComponents} from "../../framework/components/_components";
import {EventBus} from "./modules/event-bus";
import {useHeader} from "./modules/header";

main();

function main() {
    useComponents();
    useHeader();
}

document.addEventListener('DOMContentLoaded', () => {
    (<any>window).hdEventBus = new EventBus();
});
